/* Open the 'schedule a tour general modal' modal */

export function open_tour_general_modal() {

	( ( $ ) => {

		const init = () => {

			// Function to check if Bootstrap modal is available and open the modal
			const tryOpenModal = () => {
				if ( typeof $.fn.modal === 'function' ) {
					// Open the modal using Bootstrap's modal function
					$( '#schedule-a-tour-general-modal' ).modal( 'show' );
				} else {
					// Retry after 500ms if modal function is still not available
					setTimeout( tryOpenModal, 500 );
				}
			};

			// Check if the URL hash matches the modal ID and attempt to open the modal
			if ( window.location.hash.toLowerCase() === '#schedule-a-tour-general-modal' ) {
				tryOpenModal(); // Call the retry function to open the modal
			}
		}

		init();

	} )( window.jQuery );

}
